import { Action } from '@ngrx/store';

export enum EActiveYearActions {
  Changed = '[Active Year] CHANGED'
}

export class ActiveYearChanged implements Action {
  public readonly type = EActiveYearActions.Changed;
  constructor(public payload: { year: number }) {}
}
